/*
 * Sign-in with Microsoft, in Access Control: each of the admin's
 * organisations' directory and the application it registered for Weavian
 * there, which its people sign in to on their laptops (server/pkg/idp). The
 * server checks the directory with Microsoft before it keeps anything, and
 * any change signs the organisation's people out. Wording lives in
 * accessWords.js.
 *
 * ! file components/SignInSettings.js
 */
import React, { useState } from "react";
import { FiLogIn } from "react-icons/fi";
import * as W from "./accessWords";

export default function SignInSettings({ orgs, send, busy, reload, toast, confirm }) {
  return (
    <div className="panel">
      <div className="panel-title">
        <FiLogIn style={{ verticalAlign: "-2px", marginRight: 8 }} />
        {W.SIGNIN_TITLE}
      </div>
      <div className="panel-sub">{W.SIGNIN_LEAD}</div>
      <details className="ac-howto">
        <summary>{W.SIGNIN_HOWTO}</summary>
        <ol>
          {W.SIGNIN_STEPS.map((step) => (
            <li key={step}>{step}</li>
          ))}
        </ol>
      </details>
      {orgs.map((org) => (
        <OrgSignIn
          key={org.id}
          org={org}
          many={orgs.length > 1}
          send={send}
          busy={busy}
          reload={reload}
          toast={toast}
          confirm={confirm}
        />
      ))}
    </div>
  );
}

function OrgSignIn({ org, many, send, busy, reload, toast, confirm }) {
  const saved = org.settings;
  const [form, setForm] = useState({
    tenant: saved?.tenant || "",
    client_id: saved?.client_id || "",
    session_hours: saved?.session_hours || 12,
  });
  const name = org.name || org.id;

  const save = async (e) => {
    e.preventDefault();
    if (saved) {
      const ok = await confirm({
        title: W.signInChangeTitle(name),
        message: W.SIGNIN_CHANGE_MEANS,
        confirmLabel: W.SAVE,
      });
      if (!ok) return;
    }
    try {
      await send(`/signin/${encodeURIComponent(org.id)}`, "PUT", {
        tenant: form.tenant.trim(),
        client_id: form.client_id.trim(),
        session_hours: Number(form.session_hours),
      }, 20000);
      toast.success(W.signInOn(name));
      reload();
    } catch (err) {
      toast.error(err.message);
    }
  };

  const turnOff = async () => {
    const ok = await confirm({
      title: W.signInOffTitle(name),
      message: W.SIGNIN_CHANGE_MEANS,
      confirmLabel: W.TURN_OFF,
      variant: "danger",
    });
    if (!ok) return;
    try {
      await send(`/signin/${encodeURIComponent(org.id)}`, "DELETE");
      toast.success(W.signInOff(name));
      reload();
    } catch (err) {
      toast.error(err.message);
    }
  };

  return (
    <form onSubmit={save} className="ac-newform" aria-label={W.signInFor(name)}>
      <div className="ac-row-title">
        {many && name}
        <span className={`ac-tag ${saved ? "self" : "off"}`}>{saved ? W.SIGNIN_ON : W.SIGNIN_NOT_SET}</span>
      </div>
      <div className="ac-grid">
        <label className="ac-field">
          <span>{W.TENANT_ID}</span>
          <input
            className="ac-input ac-guid"
            value={form.tenant}
            onChange={(e) => setForm({ ...form, tenant: e.target.value })}
            placeholder="00000000-0000-0000-0000-000000000000"
            autoComplete="off"
            spellCheck="false"
          />
        </label>
        <label className="ac-field">
          <span>{W.CLIENT_ID}</span>
          <input
            className="ac-input ac-guid"
            value={form.client_id}
            onChange={(e) => setForm({ ...form, client_id: e.target.value })}
            placeholder="00000000-0000-0000-0000-000000000000"
            autoComplete="off"
            spellCheck="false"
          />
        </label>
        <label className="ac-field">
          <span>{W.SESSION_HOURS}</span>
          <input
            className="ac-input"
            type="number"
            min={1}
            max={72}
            value={form.session_hours}
            onChange={(e) => setForm({ ...form, session_hours: e.target.value })}
          />
        </label>
      </div>
      <div className="ac-row-actions">
        <button
          type="submit"
          className="ac-btn primary"
          disabled={busy || !form.tenant.trim() || !form.client_id.trim()}
        >
          {saved ? W.SAVE : W.TURN_ON}
        </button>
        {saved && (
          <button type="button" className="ac-btn danger" onClick={turnOff} disabled={busy}>
            {W.TURN_OFF}
          </button>
        )}
      </div>
    </form>
  );
}
